import { api } from "../../../infra/api";
import { URLS } from "../../../infra/URLS";

export default async function getEstoqueContato(ContatoId: any) {
  const { data } = await api.get(`${URLS.CONTATO_ESTOQUE_API}`, {
    params: {ContatoId}
  });
  return data;
}
